import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
const VARIANT = {
    primary: 'bg-[var(--accent)] text-[var(--accent-foreground)] font-extrabold hover:opacity-90 active:opacity-80',
    secondary: 'bg-[var(--surface)] text-[var(--text)] border border-[var(--border)] font-bold hover:border-[var(--border-strong)]',
    ghost: 'bg-transparent text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--surface)] font-bold',
    danger: 'bg-[var(--urgent)] text-white font-extrabold hover:opacity-90 active:opacity-80',
};
const SIZE = {
    sm: 'h-9 px-3 text-sm rounded-[var(--radius-control)]',
    md: 'h-11 px-4 text-base rounded-[var(--radius-control)]',
    lg: 'h-12 px-5 text-base rounded-[var(--radius-control)]',
};
const BASE = 'inline-flex items-center justify-center gap-2 font-[var(--font-sans)] transition-opacity disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--border-strong)]';
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', className, type = 'button', ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, className: cn(BASE, VARIANT[variant], SIZE[size], className), ...rest }));
});
//# sourceMappingURL=Button.js.map